import * as React from 'react';
import {WrappedFieldProps} from "redux-form";
import FormGroupMultiSelect from "./form_group_multi_select";

interface IProps {
    type: string;
    isMulti?: boolean;
    required?: boolean;
    options: any;
    name: string;
    label: string;
    placeholder: string;
    require?: boolean;
}

const FormGroupMultiSelectConnectRf: React.FC<IProps & WrappedFieldProps> = (props) => {

    const {type, isMulti, required, options, name, label, placeholder, meta, input, children, require } = props;
    const hasError = !!meta.error && !!meta.touched;

    return (
        <FormGroupMultiSelect
            placeholder={placeholder}
            type={type}
            isMulti={isMulti}
            required={required}
            options={options}
            name={name}
            label={label}
            hasError={hasError}
            input={input}
            errorText={meta.error}
            children={children}
            require={require}
        />
    )
};

export default (FormGroupMultiSelectConnectRf);



// WEBPACK FOOTER //
// ./src/presentation/common/molecular/form_group/form_group_multi_select_connect_rf.tsx